<template>
  <el-breadcrumb class="breadcrumb-container" :separator="'/'">
    <el-breadcrumb-item v-for="item in list" :key="item.path">
      <span v-if="item.meta.breadcrumbTitle" class="canClick">
        <span :class="itemP.class" @click="(e) => tolink(e, itemP.path)" v-for="(itemP, indexP) in item.meta.breadcrumbPathArr" :key="indexP">{{ $route.query.id && itemP.isRedirectName ? itemP.name1 :  itemP.name}}</span>
      </span>
      <span @click="(e) => tolink(e, item.path)" v-else :class="item.path === $route.path ? 'black canClick' : 'noblack canClick'">{{ item.meta.title }}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
  export default {
    name: 'VabBreadcrumb',
    data() {
      return {
        list: this.getBreadcrumb(),
      }
    },
    watch: {
      $route() {
        this.list = this.getBreadcrumb()
        console.log(this.list)
      },
    },
    methods: {
      tolink (e, item) {
        console.log(item)
        if((item != this.$route.path) && (item.lastIndexOf('/') > 0)) {
          this.$router.replace(item)
        }
      },
      getBreadcrumb() {
        let arr = this.$route.matched.filter(
          (item) => item.name && item.meta.title
        )
        let index = arr.findIndex((item) => !!item.meta.breadcrumbTitle == true)
        index >= 0 ? arr = [arr[index]] : arr
        return arr
      },
    },
  }
</script>

<style lang="scss" scoped>
  .breadcrumb-container {
    height: $base-nav-bar-height;
    font-size: $base-font-size-default;
    line-height: $base-nav-bar-height;
    ::v-deep {
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          a {
            display: flex;
            float: left;
            font-weight: normal;
            color: #515a6e;

            i {
              margin-right: 3px;
            }
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            a {
              color: #999;
            }
          }
        }
      }
      .el-breadcrumb__separator{
        margin: 0 2px 0 0px;
        font-size: 16px !important;
        font-weight: 600;
      }
      .canClick{
        cursor: pointer;
      }
      .black{
        color: rgba(51, 51, 51, 1);
        font-size: 16px !important;
        font-weight: 600;
      }
      .noblack{
        color: #999;
        font-size: 16px !important;
        font-weight: 600;
      }
      .el-breadcrumb__item:nth-last-child(2){
        .el-breadcrumb__separator{
          margin: 0 2px 0 0px;
          color: rgba(51, 51, 51, 1) !important;
          font-size: 16px !important;
          font-weight: 600;
        }
      }
    }
  }
</style>
